import styled from "styled-components";
import { Color } from "../../../settings";

export const WYSIWYG = styled.div`
  line-height: 1.5;

  a {
    color: ${Color.black};

    &:hover {
      text-decoration: none;
    }
  }
`;
